import React, { ReactNode } from 'react'
import { Element } from 'react-bulma-components'
import { MonthDelimiter } from './month-delimiter'
import type { MonthDelimiterProps } from './month-delimiter'

export interface WeekProps {
  week: number
  weekYear: number
  children?: ReactNode
  /** When provided with startDate, renders MonthDelimiter before the week row. */
  calendarWeek?: MonthDelimiterProps['calendarWeek']
  /** Calendar range start (required if calendarWeek is provided). */
  startDate?: string
}

export const Week = ({ children, calendarWeek, startDate }: WeekProps): JSX.Element => {
  return (
    <>
      {calendarWeek != null && startDate != null && (
        <MonthDelimiter calendarWeek={calendarWeek} startDate={startDate} />
      )}
      <tr>{children}</tr>
    </>
  )
}

export interface WeekHeaderProps extends WeekProps {
  left?: ReactNode | string
  right?: ReactNode | string
}

const Header = ({ week, left, right, children }: WeekHeaderProps): JSX.Element => {
  return (
    <td>
      <Element display="flex" justifyContent="space-between">
        <Element>
          {left ? (
            left
          ) : (
            <Element renderAs="span" textWeight="bold">
              S{week}
            </Element>
          )}
        </Element>
        <Element>{right}</Element>
      </Element>
      <Element>{children}</Element>
    </td>
  )
}
Week.Header = Header
